export function onScroll(callback) {
  let frameId = 0;

  const handleScroll = () => {
    if (frameId) return;
    frameId = window.requestAnimationFrame(() => {
      frameId = 0;
      callback();
    });
  };

  window.addEventListener('scroll', handleScroll, { passive: true });

  return () => {
    window.removeEventListener('scroll', handleScroll);
    if (frameId) {
      window.cancelAnimationFrame(frameId);
    }
  };
}
